import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'
import { TravelTwoIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'
import { Outlet, useParams } from 'react-router-dom'

import { getAffectedStaff } from '../../../api/affected-staffs/get-affected-staff'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import UserNavBar from '../../../components/elements/nav-bar'
import AffectedStaffProvider from '../../../lib/contexts/affected-staff'
import NotFoundPage from '../../common/not-found'

export default function StaffPersonalSpaceLayout() {
  const { id } = useParams()

  const { data: affectedStaff, isPending } = useQuery({
    queryKey: ['affected-staff', id],
    queryFn: () => {
      if (!id) throw new Error('Affected staff ID is required')
      return getAffectedStaff(Number(id), 'FULL')
    },
    enabled: !!id
  })

  if (isPending) return <LoadingScreen />
  if (!affectedStaff) return <NotFoundPage />

  return (
    <AffectedStaffProvider affectedStaff={affectedStaff}>
      <UserNavBar
        title={
          <div className="flex items-center gap-3">
            <Typography variant="h4" color={tailwindColors.black.DEFAULT}>
              {affectedStaff.staffRequest.country?.name}
            </Typography>
            {affectedStaff.staffRequest.startDate && affectedStaff.staffRequest.endDate && (
              <Badge
                className="mobile:hidden"
                variant="danger"
                text={`${DateFormatter.DDMMYYYY(affectedStaff.staffRequest.startDate)} - ${DateFormatter.DDMMYYYY(affectedStaff.staffRequest.endDate)}`}
              />
            )}
          </div>
        }
        icon={TravelTwoIcon}
      />
      <Outlet />
    </AffectedStaffProvider>
  )
}
